import { CareGiverCovergaeAvailability } from "./caregivers";

export type FamilyTableFilter = {
  name: string | null;
  surname: string | null;
  age: string | null;
  withCaregiver: boolean;
  noCaregiver: boolean;
  coverage: CareGiverCovergaeAvailability | null;
}

export type CaregiverTableFilter = {
  name: string | null;
  surname: string | null;
  age: string | null;
  engaged: boolean;
  notEngaged: boolean;
  coverage: CareGiverCovergaeAvailability | null;
}

export type CalculationHistoryTableFilters = {
  from: number | null;
  to: number | null;
  family: string | null;
  caregiver: string | null;
  result: CalculationStringResult | null;
}

export const EXCELLENT_CALCULATION_RESULT = 'OTTIMO' as const;
export const GOOD_CALCULATION_RESULT = 'BUONO' as const;
export const SUFFICIENT_CALCULATION_RESULT = 'SUFFICIENTE' as const;
export const INSUFFICIENT_CALCULATION_RESULT = 'INSUFFICIENTE' as const;
export const CALCULATION_RESULTS = [GOOD_CALCULATION_RESULT, SUFFICIENT_CALCULATION_RESULT, INSUFFICIENT_CALCULATION_RESULT, EXCELLENT_CALCULATION_RESULT] as const;
export type CalculationStringResult = typeof CALCULATION_RESULTS[number];

export const CALCULATION_RESULT_SELECTOR_DATA: {
  key: CalculationStringResult;
  value: CalculationStringResult;
}[] = [
  { key: EXCELLENT_CALCULATION_RESULT, value: EXCELLENT_CALCULATION_RESULT },
  { key: GOOD_CALCULATION_RESULT, value: GOOD_CALCULATION_RESULT },
  { key: SUFFICIENT_CALCULATION_RESULT, value: SUFFICIENT_CALCULATION_RESULT },
  { key: INSUFFICIENT_CALCULATION_RESULT, value: INSUFFICIENT_CALCULATION_RESULT },
]